import { render, staticRenderFns } from "./mjoinus.vue?vue&type=template&id=d71ea382&scoped=true"
import script from "./mjoinus.vue?vue&type=script&lang=js"
export * from "./mjoinus.vue?vue&type=script&lang=js"
import style0 from "./mjoinus.vue?vue&type=style&index=0&id=d71ea382&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0__lodash_sniwsisxdvcgzet3yrvlfqnueq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71ea382",
  null
  
)

export default component.exports